document.addEventListener("DOMContentLoaded", function () {
  const article = document.querySelector(".article-template");
  const headers = article ? article.querySelectorAll("h2, h3") : [];
  if (!headers.length) return;

  const summary = document.getElementById("summary");
  if (!summary) return;

  const summaryList = document.createElement("ul");

  headers.forEach((header, index) => {
    const id = header.textContent
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "") + "-" + index;
    header.setAttribute("id", id);

    const listItem = document.createElement("li");
    listItem.style.marginBottom = "2px";

    const link = document.createElement("a");
    link.href = "#" + id;
    link.textContent = header.textContent;
    link.style.textDecoration = "none";

    listItem.appendChild(link);
    summaryList.appendChild(listItem);
  });

  summary.innerHTML = "<h3>Sommaire</h3>";
  summary.appendChild(summaryList);

});
